import { compose } from 'redux';
import { connect } from 'react-redux';
import selectors from '../../../rootSelectors';
import { fetchSpellingContent, selectPossibleResponses } from '../../spellingActions';
import * as multiChoiceUtils from '../../../common/questions/multiChoiceQuestionUtils';
import SpellingView from '../../SpellingView';
import AvatarView from '../../../common/avatar/avatarView';
import withAvatar from '../../../common/avatar/withAvatar';
import {
    resetSelectedMultiChoiceIndexes,
    resetQuestionsAndTimeTrackingState,
} from '../../../common/questions/questionsActions';
import { SPELLING_AUDIO_INSTRUCTIONS } from '../../spellingConstants';
import { SPELLING } from '../../../constants/measure';
import { narratePracticeScreen, onResponseSelect, onNext } from './SpellingPracticeActions';
import { PRACTICE } from '../../../constants/assessmentItemType';
import {
    blockScreen,
    unblockScreen,
    deactivateNextButton,
    unmountScreen,
    togglePointerVisibility,
} from '../../../common/screen/screenActions';
import { stopAudio, narrateStart, narrateReset } from '../../../common/audio/audioActions';
import { getAvatarPosition } from '../../../common/alex/AlexUtils';

const mapStateToProps = state => {
    const props = multiChoiceUtils.mapStateToProps(state);
    return {
        ...props,
        pageLayout: `${SPELLING.ASSESSMENT}`,
        isDataFetched: selectors.getIsSpellingDataFetched(state),
        isPointerClicked: selectors.getIsPointerClicked(state),
        pointerPosition: selectors.getPointerPosition(state),
        isPointerVisible: selectors.getIsPointerVisible(state),
        stimulus: selectors.getSpellingStimulus(state, PRACTICE),
        selectedResponses: selectors.getMultiChoiceResponses(state),
        isButtonGridEnabled: selectors.getIsButtonGridEnabled(state),
        isClearButtonEnabled: selectors.getIsClearButtonEnabled(state),
        enabledResponses: selectors.getSpellingEnabledResponses(state),
        isNextButtonClickable: selectors.getIsNextButtonClickable(state),
        currentLanguage: selectors.getCurrentLanguage(state),
    };
};

const mapDispatchToProps = dispatch => {
    const props = multiChoiceUtils.mapDispatchToProps(dispatch);
    return {
        ...props,
        fetchContent: () => {
            dispatch(fetchSpellingContent());
        },
        narrateScreen: async stimulusAudio => {
            dispatch(blockScreen());
            dispatch(narrateStart());
            dispatch(togglePointerVisibility());
            await dispatch(narratePracticeScreen(stimulusAudio));
            dispatch(narrateReset());
            dispatch(unblockScreen());
        },
        selectResponse: letter => {
            dispatch(selectPossibleResponses(letter));
            dispatch(onResponseSelect(letter));
        },
        onNext: () => {
            dispatch(onNext());
        },
        resetSelectedResponses: () => {
            dispatch(resetSelectedMultiChoiceIndexes());
            dispatch(deactivateNextButton());
        },
        cleanup: () => {
            dispatch(stopAudio());
            dispatch(narrateReset());
            dispatch(resetQuestionsAndTimeTrackingState());
            dispatch(resetSelectedMultiChoiceIndexes());
            dispatch(unmountScreen());
        },
    };
};

const avatarMapStateToProps = state => {
    const positionConfig = {
        alyxPosition: AvatarView.Position.TOP_HEADER_CENTER,
        defaultViewPosition: AvatarView.Position.LOWER_LEFT,
    };
    const position = getAvatarPosition(positionConfig);
    return {
        position,
        animateAlex: true,
        instructions:
            SPELLING_AUDIO_INSTRUCTIONS[selectors.getCurrentLanguage(state)]
                .spellingPracticeInstructionStart,
    };
};

const SpellingPracticeContainer = compose(
    connect(mapStateToProps, mapDispatchToProps),
    withAvatar(avatarMapStateToProps),
)(SpellingView);

export default SpellingPracticeContainer;
